import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DepartmentHierarchy from "./DepartmentHierarchy";
import MembersHierarchy from "./MembersHierarchy";
import {
  DepartmentHierarchyIcon,
  MembersHierarchyIcon,
  UploadIcon,
  DownloadIcon,
  DownloadTemplateIcon,
} from "../../../shared-resources/SVGIcons";
import { Drawer, makeStyles } from "@material-ui/core";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import CloseIcon from "@material-ui/icons/Close";
import {
  downloadCreateDepartmentTemplateExcelFile,
  createDepartmentFromExcel,
  downloadDepartmentDetailsExcelFile,
} from "../../../actions/admin-actions";
import { downloadFile } from "../../../shared-resources/utils";
import FileUpload from "../../../common-components/FileUpload";

const HierarchyContainer = ({
  nodesData,
  departmentsResources,
  resourceHierarchy,
}) => {
  const useStyles = makeStyles((theme) => ({
    saveBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      // boxShadow: "inset 3px 3px 11px #0000009C, 0px 3px 6px #00000029",
      // background: "#0176D3 0% 0% no-repeat padding-box !important",
    },
    closeSection: {
      position: "absolute",
      cursor: "pointer",
      right: theme.spacing(0.25),
      top: theme.spacing(0.25),
    },
    closeIcon: {
      color: "#C4C4C4",
    },
    drawerDataSection: {
      position: "relative",
      padding: "6px 32px",
    },
    drawerTitle: {
      color: "#0082CA",
      fontSize: theme.spacing(2.25),
      marginBottom: theme.spacing(2),
    },
    uploadDescription: {
      marginBottom: theme.spacing(2),
    },
  }));

  const classes = useStyles();
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState("departments");
  const [openDrawerUpload, setOpenDrawerUpload] = useState(false);
  const [isDownloadClick, setIsDownloadClick] = useState(false);
  const [isUploadClick, setIsUploadClick] = useState(false);
  const [isDownloadDepartmentsClick, setIsDownloadDepartmentsClick] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();

  const downloadCreateDepartmentTemplateExcelFileData = useSelector(
    (state) => state.adminReducer.downloadCreateDepartmentTemplateExcelFile
  );
  const createDepartmentFromExcelData = useSelector(
    (state) => state.adminReducer.createDepartmentFromExcel
  );
  const downloadDepartmentsData = useSelector(
    (state) => state.adminReducer.downloadDepartmentsData
  );

  const toggleDrawerUpload = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawerUpload(open);
  };
  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };
  const downloadExcel = () => {
    setIsDownloadClick(true);
    dispatch(downloadCreateDepartmentTemplateExcelFile());
    setLoading(true);
  };

  const downloadDepartments = () => {
    setIsDownloadDepartmentsClick(true);
    dispatch(downloadDepartmentDetailsExcelFile());
    setLoading(true);
  };

  const uploadFile = (formData) => {
    dispatch(createDepartmentFromExcel(formData));
    setLoading(true);
    setIsUploadClick(true);
  };
  useEffect(() => {
    if (downloadCreateDepartmentTemplateExcelFileData.type && isDownloadClick) {
      setLoading(false);
      downloadFile(
        downloadCreateDepartmentTemplateExcelFileData,
        "createDepartment"
      );
      setIsDownloadClick(false);
    }
  }, [downloadCreateDepartmentTemplateExcelFileData]);

  useEffect(() => {
    if (downloadDepartmentsData.type && isDownloadDepartmentsClick) {
      setLoading(false);
      downloadFile(downloadDepartmentsData, "departments");
      setIsDownloadDepartmentsClick(false);
    }
  }, [downloadDepartmentsData]);

  useEffect(() => {
    if (createDepartmentFromExcelData.type && isUploadClick) {
      setLoading(false);
      setIsUploadClick(false);
      setEmptyErrMsg(true);
      setMsgText("File processed successfully. Please check");
      downloadFile(createDepartmentFromExcelData, "uploadedFile");
      setOpenDrawerUpload(false);
      setMsgType("success");
    }
  }, [createDepartmentFromExcelData]);
  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          padding: "5px 15px",
        }}
      >
        <span
          onClick={() => setCurrentPage("departments")}
          style={{
            // color: currentPage === "departments" ? "#0176d3" : "",
            color: "#085F93",
            textDecoration: currentPage === "departments" && "underline",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          <span style={{ marginRight: "5px" }}>
            <DepartmentHierarchyIcon />
          </span>
          Departments
        </span>
        <span
          onClick={() => setCurrentPage("members")}
          style={{
            // color: currentPage === "members" ? "#0176d3" : "",
            color: "#085F93",
            textDecoration: currentPage === "members" && "underline",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          <span style={{ marginRight: "5px" }}>
            <MembersHierarchyIcon />
          </span>
          Members
        </span>
        {currentPage === "departments" && (
          <span
            style={{
              cursor: "pointer",
              marginRight: "6px",
              position: "absolute",
              right: "64px",
              top: "2px",
            }}
            title="Download Departments"
            onClick={() => downloadDepartments()}
          >
            <DownloadIcon background="#0070D2" color="#fff" />
          </span>
        )}

        <span
          style={{
            cursor: "pointer",
            marginRight: "6px",
            position: "absolute",
            right: "29px",
            top: "10px",
          }}
          title="Download Template"
          onClick={() => downloadExcel()}
        >
          <DownloadTemplateIcon />
        </span>
        <span
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "0px",
            top: "2px",
          }}
          title={
            currentPage === "departments"
              ? "Upload Departments"
              : "Upload Members"
          }
          onClick={toggleDrawerUpload(true)}
        >
          <UploadIcon background="#0070D2" color="#fff" />
        </span>
      </div>
      {currentPage == "departments" ? (
        <DepartmentHierarchy
          nodesData={nodesData}
          departmentsResources={departmentsResources}
        />
      ) : (
        <MembersHierarchy nodesData={resourceHierarchy} />
      )}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
      <Drawer
        anchor="right"
        open={openDrawerUpload}
        onClose={toggleDrawerUpload(false)}
      >
        <div className={classes.drawerDataSection}>
          <div className={classes.drawerTitle}>Bulk Upload</div>
          <div className={classes.uploadDescription}>
            Please Drag and Drop or select the required files
          </div>
          <div
            className={classes.closeSection}
            onClick={toggleDrawerUpload(false)}
          >
            <CloseIcon className={classes.closeIcon} />
          </div>
          <FileUpload getFormData={uploadFile} />
        </div>
      </Drawer>
    </div>
  );
};

export default HierarchyContainer;
